var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 .4C5.6.4.4 5.6.4 12S5.6 23.6 12 23.6 23.6 18.4 23.6 12 18.4.4 12 .4zm0 22.2C6.1 22.6 1.4 17.9 1.4 12S6.1 1.4 12 1.4 22.6 6.2 22.6 12 17.9 22.6 12 22.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9 8.1c-.2-.2-.5-.2-.7 0L12 11.3 8.8 8.1c-.2-.2-.5-.2-.7 0s-.2.5 0 .7l3.2 3.2-3.2 3.2c-.2.2-.2.5 0 .7.1.1.2.1.4.1s.3 0 .4-.1l3.2-3.2 3.2 3.2c.1.1.2.1.4.1s.3 0 .4-.1c.2-.2.2-.5 0-.7L12.7 12l3.2-3.2c.2-.2.2-.5 0-.7z"
  })));
};
export default SvgClose;